import { InsuranceTypes, SelectInsuranceProvider } from 'models/insurance.types';

import { WizardApiPlanRow, WizardInsurancePlan } from './insurance.types';

export const mapWizardApiPlanRow = (row: WizardApiPlanRow): WizardInsurancePlan => {
  const insuranceType = row.insuranceType ?? '';
  const isMedicare =
    insuranceType === 'medicare' || insuranceType.toLowerCase().includes('medicare');

  return {
    displayName: row.name,
    id: row._id,
    insuranceType,
    isMedicare,
    isPopular: row.isDiscoverable ?? false,
    name: row.name,
    payerId: row.payerId,
    rxBIN: row.rxBIN,
    rxPCN: row.rxPCN
  };
};

export const mapWizardPlanToInsuranceProvider = (
  plan: WizardInsurancePlan
): SelectInsuranceProvider => ({
  _id: plan.id,
  insuranceType: plan.insuranceType as InsuranceTypes,
  isDiscoverable: plan.isPopular,
  label: plan.displayName,
  value: plan.payerId
});

export const mapInsuranceProviderToWizardPlan = (
  provider: SelectInsuranceProvider
): WizardInsurancePlan => {
  const insuranceType = provider.insuranceType ?? '';
  const isMedicare =
    insuranceType === 'medicare' || insuranceType.toLowerCase().includes('medicare');

  return {
    displayName: provider.label,
    id: provider._id,
    insuranceType,
    isMedicare,
    isPopular: provider.isDiscoverable ?? false,
    name: provider.label,
    payerId: provider.value
  };
};

export const normalizeWizardPlansResponse = (
  data: WizardApiPlanRow[] | { plans: WizardInsurancePlan[]; total: number } | null | undefined
): WizardInsurancePlan[] => {
  if (!data) {
    return [];
  }
  if (Array.isArray(data)) {
    return data.map(mapWizardApiPlanRow);
  }
  if ('plans' in data && Array.isArray(data.plans)) {
    return data.plans;
  }
  return [];
};
